import { render, staticRenderFns } from "./real_time.vue?vue&type=template&id=e4b1ec3c&scoped=true&"
import script from "./real_time.vue?vue&type=script&lang=js&"
export * from "./real_time.vue?vue&type=script&lang=js&"
import style0 from "./real_time.vue?vue&type=style&index=0&id=e4b1ec3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b1ec3c",
  null
  
)

export default component.exports